export default __webpack_public_path__ + "static/media/cards-black.e0be4eb0.svg";